<template>
  <div class="love-card" @click="$emit('click')">
    <!-- Photo -->
    <div class="love-card-image">
      <img :src="userPhoto" :alt="user.name" class="love-card-photo">
    </div>

    <!-- Info -->
    <div class="love-card-info">
      <h3 class="love-card-name">
        {{ user.name }}
      </h3>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { getProfileCardImage } from '../../lib/imageUtils'

const props = defineProps({
  user: Object
})

defineEmits(['click'])

const userPhoto = computed(() => {
  let originalUrl

  if (props.user.thumbnail_url) {
    originalUrl = props.user.thumbnail_url
  } else {
    const primaryPhoto = props.user.profile_photos?.find(p => p.is_thumbnail)
    originalUrl =
      primaryPhoto?.photo_url || props.user.profile_photos?.[0]?.photo_url || '/placeholder.png'
  }

  // Apply profile card optimization (300x375px for better face preservation)
  return getProfileCardImage(originalUrl)
})
</script>
